<template lang="html">
	<div class="px-1">
		<nav class='bg-gray-100 dark:bg-gray-900 px-2 py-2 flex space-x-2 justify-between'>
			<button class="grow px-2 py-2 rounded-md text-gray-800 dark:text-gray-200 select-none" :class="mobileNav == 'continuity' ? 'bg-white dark:bg-black shadow' : 'bg-gray-200 dark:bg-gray-700 shadow-inner'" @click="mobileNav = 'continuity'" v-show="product == 'mirror_shoot'"> Continuity </button>
			<button class="grow px-2 py-2 rounded-md text-gray-800 dark:text-gray-200 select-none" :class="mobileNav == 'shooting_board' ? 'bg-white dark:bg-black shadow' : 'bg-gray-200 dark:bg-gray-700 shadow-inner'" @click="mobileNav = 'shooting_board'" v-show="product == 'mirror_shoot'">Shooting board</button>
			<button class="grow px-2 py-2 rounded-md text-gray-800 dark:text-gray-200 select-none" :class="mobileNav == 'stills' ? 'bg-white dark:bg-black shadow' : 'bg-gray-200 dark:bg-gray-700 shadow-inner'" @click="mobileNav = 'stills'" v-show="product == 'mirror_shoot'"> Photos </button>
			<button class="grow px-2 py-2 rounded-md text-gray-800 dark:text-gray-200 select-none" :class="mobileNav == 'participants' ? 'bg-white dark:bg-black shadow' : 'bg-gray-200 dark:bg-gray-700 shadow-inner'" @click="mobileNav = 'participants'">Participants</button>
		</nav>
		<main class="h-128 sm:h-72 px-4 py-4 bg-gray-100 dark:bg-gray-900">
			<stills ref="stills" :is-director="true" grid-size='gap-3 grid-cols-5 sm:grid-cols-10' v-show="mobileNav == 'stills'" v-on:requestFocus="mobileNav = 'stills'"></stills>
         <continuity ref="continuity" :is-director="true" v-show="mobileNav == 'continuity'"></continuity>
         <shooting-board ref="shootingBoard" :is-guest="true" v-show="mobileNav == 'shooting_board'" v-on:requestFocus="mobileNav = 'shooting_board'"></shooting-board>
            <!--  Participants -->
            <div class="" v-show="mobileNav == 'participants'">
					 <div class="font-light">
						  <span class="userName"></span>
					 </div>
					 <participant ref="meParticipant" class="slide-in-item" :peer='{ id: "soundMeterMainTower", name: "Me", role: "Me", status: "connected", audio_input: "this is not defined a peer not_defined", latency: 0, upload_speed: -1, download_speed: -1}' :showActions="false"></participant>
               <mirror-participant-list ref="participantList" class="h-48 pt-2"></mirror-participant-list>
            </div>
				<!-- end of participants -->
		</main>
	</div>
</template>
<script>
export default {
  data() {
		return {
      product: "mirror_shoot",
			mobileNav: 'participants',
          showReview: false,
        }
	},
  mounted(){
    const browser = detectBrowser(window);
    if (browser.browser === 'safari' && browser.version >= 605 && (browser.iphone || browser.ipad)) {
      this.showReview = true;
			this.mobileNav = 'review'

      }
    this.product = window.product;
    if (product == "mirror_shoot") {
      this.mobileNav = "continuity"
    }
  }
}
</script>
<style lang="">

</style>
